import React from "react";

const LinkedIn = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4457 5.69934C7.44546 6.17673 7.25559 6.63447 6.91786 6.97187C6.58012 7.30926 6.12219 7.49868 5.6448 7.49844C5.16741 7.4982 4.70967 7.30833 4.37227 6.97059C4.03488 6.63286 3.84546 6.17493 3.8457 5.69754C3.84594 5.22015 4.03581 4.76241 4.37355 4.42501C4.71128 4.08761 5.16921 3.8982 5.6466 3.89844C6.12399 3.89868 6.58174 4.08855 6.91913 4.42628C7.25653 4.76402 7.44594 5.22195 7.4457 5.69934ZM7.4997 8.83134H3.8997V20.0993H7.4997V8.83134ZM13.1877 8.83134H9.6057V20.0993H13.1517V14.1863C13.1517 10.8923 17.4447 10.5863 17.4447 14.1863V20.0993H20.9997V12.9623C20.9997 7.40934 14.6457 7.61634 13.1517 10.3433L13.1877 8.83134Z"
        fill="#DDF3F6"
      />
    </svg>
  );
};

export default LinkedIn;
